/* MARAYA: visible-only muted previews, with recoverable browser-policy fallback. */
(function () {
  'use strict';
  if (window.MarayaProductMediaLoaded) return;
  window.MarayaProductMediaLoaded = true;
  var videos = [];
  var states = new WeakMap();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var connection = navigator.connection;
  function allowed() {
    return !document.hidden && !reduced.matches && !(connection && connection.saveData) &&
      !document.querySelector('.mr-reel-modal.is-open,.mr-video-modal.is-open');
  }
  function status(video, value) {
    video.dataset.autoplayState = value;
    var host = video.closest('.mr-reel,.mr-video-overlay');
    if (!host) return;
    host.dataset.autoplayState = value;
    host.classList.toggle('is-playing', value === 'playing');
  }
  function shouldPlay(video) {
    var state = states.get(video);
    return !!(state && state.visible && video.isConnected && allowed());
  }
  function update(video) {
    var state = states.get(video);
    if (!shouldPlay(video)) {
      if (!video.paused) video.pause();
      if (reduced.matches || (connection && connection.saveData)) status(video, 'manual');
      return;
    }
    if (state.blocked || !video.paused) return;
    if (state.pending) { state.resumeAfterRequest = true; return; }
    video.defaultMuted = true;
    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    if (!video.getAttribute('src')) {
      var source = video.getAttribute('data-src');
      if (!source) { status(video, 'blocked'); return; }
      video.src = source;
      video.load();
    }
    state.pending = true;
    var result;
    try { result = video.play(); } catch (error) { result = Promise.reject(error); }
    Promise.resolve(result).then(function () {
      if (!shouldPlay(video)) video.pause();
    }).catch(function (error) {
      if (!error || error.name !== 'AbortError') {
        state.blocked = true;
        status(video, 'blocked');
      }
    }).finally(function () {
      state.pending = false;
      if (state.resumeAfterRequest) { state.resumeAfterRequest = false; update(video); }
    });
  }
  function sync() { videos.forEach(update); }
  var observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var state = states.get(entry.target);
      state.visible = entry.isIntersecting && entry.intersectionRatio >= .35;
      update(entry.target);
    });
  }, { threshold: [0, .35], rootMargin: '0px' }) : null;
  function init(root) {
    videos = videos.filter(function (video) {
      if (video.isConnected) return true;
      video.pause();
      if (observer) observer.unobserve(video);
      return false;
    });
    root.querySelectorAll('video[data-mr-autoplay]').forEach(function (video) {
      if (states.has(video)) return;
      states.set(video, { visible: false, pending: false, blocked: false });
      videos.push(video);
      video.addEventListener('playing', function () {
        if (!shouldPlay(video)) { video.pause(); return; }
        states.get(video).blocked = false;
        status(video, 'playing');
      });
      video.addEventListener('pause', function () {
        status(video, states.get(video).blocked ? 'blocked' : 'paused');
      });
      video.addEventListener('error', function () {
        states.get(video).blocked = true;
        status(video, 'blocked');
      });
      if (observer) observer.observe(video);
      if (!observer || reduced.matches || (connection && connection.saveData)) status(video, 'manual');
    });
  }
  function retryVisible() {
    if (!allowed()) return;
    videos.forEach(function (video) {
      var state = states.get(video);
      if (!state.visible) return;
      state.blocked = false;
      if (video.error) video.load();
      update(video);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else init(document);
  document.addEventListener('visibilitychange', sync);
  document.addEventListener('mr:product-media:state', sync);
  document.addEventListener('click', retryVisible);
  document.addEventListener('touchend', retryVisible, { passive: true });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (reduced.addEventListener) reduced.addEventListener('change', function () { retryVisible(); sync(); });
  window.addEventListener('pagehide', function () { videos.forEach(function (video) { video.pause(); }); });
  window.addEventListener('pageshow', retryVisible);
})();
